import LocalStorage from "@src/libraries/LocalStorage";
import http from "@src/assets/js/requests/http";
import storage, { ONLINE_CACHE_TIME } from "@src/assets/js/requests/storage";
import { fakePromise, headerAttr, stringify } from "@src/assets/js/utils";
import { silentReport } from '@src/assets/js/report';
import store from "@src/store";
const REQUEST_CACHE_TIME = ONLINE_CACHE_TIME * 60;
export default {
    pub(key, type) {
        const headers = {};
        const asyncData = store.getAsyncData(key, type);
        if (asyncData)
            return asyncData;
        headers.Authorization = headers.Authorization || "";
        return this.get(key, type, headers);
    },
    async get(key, type, headers) {
        if (LocalStorage.getItem("admin")) {
            return http.get(key, type, headers);
        }
        headers = headers || {};
        headers["cache-control"] = headers["cache-control"] || ("max-age=" + REQUEST_CACHE_TIME);
        const data = await storageRequest(key, type, headers);
        if (data)
            return data;
        return http.get(key, type, headers);
    },
    stale(key, type, headers) {
        headers = headers || {};
        if (LocalStorage.getItem("admin")) {
            return http.get(key, type, headers);
        }
        headers.Authorization = headers.Authorization || "";
        return fakePromise(async function (resolve) {
            const stale = await storage.stale(key, type);
            if (stale) {
                resolve(stale);
                const cacheTimeOver = await storage.cacheTimeOver(key, headers);
                if (!cacheTimeOver) {
                    return;
                }
            }
            headers = headers || {};
            headers["cache-control"] = headers["cache-control"] || ("max-age=" + REQUEST_CACHE_TIME);
            const httpResponse = await http.get(key, type, headers);
            if (!httpResponse || stringify(httpResponse) == stringify(stale)) {
                return;
            }
            resolve(httpResponse);
        });
    },
    async findMultiple(controller, ids, query = "", headers) {
        if (!ids.length)
            return [];
        if (!headers) {
            headers = {};
            if (!LocalStorage.getItem("admin")) {
                headers.Authorization = headers.Authorization || "";
            }
        }
        const results = [];
        const storageRequests = [];
        for (const id of ids) {
            const req = controller + "/" + id + query;
            storageRequests.push(storageRequest(req, "Object", headers));
        }
        const storageResults = await Promise.all(storageRequests);
        const httpIds = [];
        for (let i = 0; i < ids.length; i++) {
            const id = ids[i];
            if (storageResults[i] && storageResults[i].id == id) {
                results.push(storageResults[i]);
            }
            else {
                httpIds.push(id);
            }
        }
        if (httpIds.length) {
            const and = query ? "&" : "?";
            const req = controller + query + and + "id=" + httpIds.join(",");
            const httpResults = await http.get(req, "Array", headers);
            if (!httpResults || !httpResults.length) {
                silentReport("!httpResults", { req });
                return results;
            }
            for (const httpResult of httpResults) {
                storage.set(controller + "/" + httpResult.id + query, httpResult, {
                    original: true
                });
            }
            results.push(...httpResults);
        }
        return results;
    },
};
async function storageRequest(key, type, headers, httpFallback) {
    const maxAge = Number(headerAttr(headers, "cache-control", "max-age"));
    const noCache = headers && "max-age=0, no-cache, no-store, private" == headers["cache-control"];
    const fromCache = (0 !== maxAge && !noCache);
    if (!fromCache) {
        return;
    }
    const data = await storage.get(key, type, headers, httpFallback);
    const empty = "undefined" === typeof data || null === data;
    const emptyArray = data && Object.prototype.toString.call(data) === "[object Array]" && !data.length;
    const emptyObject = data && data.constructor === Object && Object.keys(data).length === 0;
    if (empty || emptyArray || emptyObject) {
        return;
    }
    return data;
}
